import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GoToastModule } from '@go-modules/components/go-toast/go-toast.module';
import { NgxRichTextEditorModule } from '@go-modules/components/rich-text-editor/rich-text-editor.module';
import { NgxFeedbackCreatorComponent } from './feedback-creator.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MarkerModule } from '@go-modules/components/marker/marker.module';
import { NgxMediaThumbnailModule } from '../../media-thumbnail/media-thumbnail.module';
import { A11yModule } from '@angular/cdk/a11y';
import { AICommentAssistantMenuModule } from '@go-modules/components/menus/ai-comment-assistant-menu/ai-comment-assistant-menu.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		TextFieldModule,
		GoToastModule,
		GoMaterialModule,
		MatTooltipModule,
		NgxRichTextEditorModule,
		FormatTimeModule,
		PickerModule,
		MarkerModule,
		NgxMediaThumbnailModule,
		A11yModule,
		AICommentAssistantMenuModule
	],
	declarations: [
		NgxFeedbackCreatorComponent
	],
	exports: [
		NgxFeedbackCreatorComponent
	],
	providers: []
})
export class FeedbackCreatorModule {}
